(() => {
  if (window.__taggedCatalogCarouselEdgeInit) return;
  window.__taggedCatalogCarouselEdgeInit = true;

  const COOLDOWN_MS = 520;
  const lastAt = new WeakMap();
  let touchStartX = 0;

  function maxScroll(el) {
    return Math.max(0, el.scrollWidth - el.clientWidth);
  }

  function isRtl(el) {
    return getComputedStyle(el).direction === "rtl";
  }

  function atStart(el) {
    const max = maxScroll(el);
    if (max <= 0) return true;
    const s = el.scrollLeft;
    return isRtl(el) ? s >= max - 4 : s <= 4;
  }

  function atEnd(el) {
    const max = maxScroll(el);
    if (max <= 0) return true;
    const s = el.scrollLeft;
    return isRtl(el) ? s <= 4 : s >= max - 4;
  }

  function canFire(el) {
    const t = lastAt.get(el) || 0;
    if (Date.now() - t < COOLDOWN_MS) return false;
    lastAt.set(el, Date.now());
    return true;
  }

  function bounce(el, side) {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    if (!canFire(el)) return;
    if (typeof el.animate !== "function") return;

    if (el._taggedCatalogEdgeAnim) {
      try {
        el._taggedCatalogEdgeAnim.cancel();
      } catch (_) {}
      el._taggedCatalogEdgeAnim = null;
    }

    const rtl = isRtl(el);
    const pull = rtl ? 1 : -1;
    const push = rtl ? -1 : 1;

    const frames =
      side === "end"
        ? [
            { transform: "translate3d(0,0,0)" },
            { transform: `translate3d(${18 * pull}px,0,0)` },
            { transform: `translate3d(${6 * push}px,0,0)` },
            { transform: "translate3d(0,0,0)" },
          ]
        : [
            { transform: "translate3d(0,0,0)" },
            { transform: `translate3d(${18 * push}px,0,0)` },
            { transform: `translate3d(${6 * pull}px,0,0)` },
            { transform: "translate3d(0,0,0)" },
          ];

    const anim = el.animate(frames, {
      duration: 420,
      easing: "cubic-bezier(0.33, 1.12, 0.52, 1)",
    });
    el._taggedCatalogEdgeAnim = anim;
    anim.onfinish = () => {
      el._taggedCatalogEdgeAnim = null;
    };
  }

  function onWheel(e) {
    const el = e.target.closest?.("scroll-carousel[data-edge-bounce]");
    if (!el || maxScroll(el) < 4) return;

    const absX = Math.abs(e.deltaX);
    const absY = Math.abs(e.deltaY);
    const deltaH = e.shiftKey ? e.deltaY : e.deltaX;

    const mostlyHorizontal = absX >= absY || e.shiftKey;
    const towardEnd =
      deltaH > 2 || (absY > absX && e.deltaY > 12 && !e.shiftKey);
    const towardStart =
      deltaH < -2 || (absY > absX && e.deltaY < -12 && !e.shiftKey);

    if (atEnd(el) && towardEnd) {
      if (mostlyHorizontal) e.preventDefault();
      bounce(el, "end");
    } else if (atStart(el) && towardStart) {
      if (mostlyHorizontal) e.preventDefault();
      bounce(el, "start");
    }
  }

  function onTouchMove(e) {
    const el = e.target.closest?.("scroll-carousel[data-edge-bounce]");
    if (!el || maxScroll(el) < 4 || !e.touches[0]) return;
    const x = e.touches[0].clientX;
    const dx = x - touchStartX;
    if (atEnd(el) && dx < -16) bounce(el, "end");
    else if (atStart(el) && dx > 16) bounce(el, "start");
  }

  function onKeyDown(e) {
    const el = e.target.closest?.("scroll-carousel[data-edge-bounce]");
    if (!el || maxScroll(el) < 4) return;
    if (e.key === "ArrowRight" && !e.repeat && atEnd(el)) bounce(el, "end");
    if (e.key === "ArrowLeft" && !e.repeat && atStart(el)) bounce(el, "start");
  }

  document.addEventListener("wheel", onWheel, { capture: true, passive: false });
  document.addEventListener(
    "touchstart",
    (e) => {
      const el = e.target.closest?.("scroll-carousel[data-edge-bounce]");
      if (el && e.touches[0]) touchStartX = e.touches[0].clientX;
    },
    { passive: true }
  );
  document.addEventListener("touchmove", onTouchMove, { passive: true });
  document.addEventListener("keydown", onKeyDown, true);
})();
